import { render, staticRenderFns } from "./imanage.vue?vue&type=template&id=45fad576"
import script from "./imanage.vue?vue&type=script&lang=js"
export * from "./imanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports